export const SUBMIT_FEEDBACK_URL = 'https://about.gitlab.com/submit-feedback/';
export const LICENSING_FAQ_URL = 'https://about.gitlab.com/pricing/licensing-faq/';
export const DOCUMENTATION_URL = 'https://docs.gitlab.com/subscriptions/';
